module.exports = __webpack_public_path__ + "static/media/animated-1-Ca.189bfda2.gif";